<template>
  <div>
    <PoppinsAlertBanner :status="alertStatus" class="mt-0 sm:mt-32 lg:mt-0" style="width: 100%">
      <p v-if="emailError" id="submit-error-email">
        This email is already associated with an account. Try
        <a href="/login" target="_blank">logging in</a> or contact
        <a href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank">Customer Success</a>
      </p>
      <p v-else-if="emailInvalid" id="submit-error-email-invalid">Please enter a valid email address</p>
      <p v-else id="submit-error-generic">
        Something went wrong. Try reloading or contact
        <a href="https://support.sittercity.com/hc/en-us/requests/new" target="_blank">Customer Success</a>
      </p>
    </PoppinsAlertBanner>
  </div>
</template>

<script lang="ts">
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';
import HelperStatus from '@/helpers/status';

export default {
  name: 'SitterAlertBanner',
  components: {
    PoppinsAlertBanner: AlertBanner,
  },
  props: {
    error: {
      type: Error,
      default: null,
      required: false,
    },
  },
  computed: {
    // check error message to see if it's for email
    emailError(): boolean {
      return this.error?.message === 'email-not-unique';
    },
    emailInvalid(): boolean {
      return this.error?.message === 'email-invalid';
    },
    // error message determines the style of the alert
    // email gets critical style and special text
    alertStatus(): HelperStatus | null {
      if (this.emailError || this.emailInvalid) {
        return HelperStatus.Error;
      }

      return HelperStatus.Warn;
    },
  },
};
</script>
